<template>
  <div class="container">
    <!--<div class="title"><span>首页</span>>  医生列表</div>-->
    <!--<p class="yxtj">已选条件 ：已找到 <span>154736</span> 位医生</p>-->
    <div class="jgfl">
      <div class="item">
       <div class="items">
         <p>科室选择 <i></i></p>
         <ul>
           <li :class="active === 'all' ? 'active': ''" @click="depatTab('all', null)">不限</li>
           <li v-for="(item, index) in deparList" :class="active === index ? 'active': ''" :key="item.id" @click="depatTab(index, item.id)">{{item.name}}</li>
         </ul>
       </div>
        <div class="items">
          <p >医生职称 <i></i></p>
          <ul>
            <li :class="active2 === 'all' ? 'active': ''" @click="presidentTab('all', null)">不限</li>
            <li v-for="(item, index) in list2" :class="active2 === index ? 'active': ''" :key="item.id" @click="presidentTab(index, item.id)">{{item.name}}</li>
          </ul>
        </div>
        <div class="items">
          <p>医院等级 <i></i></p>
          <ul>
            <li :class="active3 === 'all' ? 'active': ''" @click="levelTab('all', null)">不限</li>
            <li v-for="(item, index) in list3" :class="active3 === index ? 'active': ''" :key="item.id" @click="levelTab(index, item.id)">{{item.name}}</li>
          </ul>
        </div>
      </div>
      <!--<div class="zk">展开 <i class="el-icon-arrow-down"></i></div>-->
    </div>
    <div class="shaixuan">
      <div class="item ac">综合 <i class="el-icon-caret-top"></i></div>
      <div class="item">好评量 <i class="el-icon-caret-bottom"></i></div>
      <div class="item">问诊量 <i class="el-icon-caret-bottom"></i></div>
      <div class="item">价格 <i class="el-icon-caret-bottom"></i></div>
    </div>
    <div class="yybox">
      <div class="item" @click="zjxq(item.id)" v-for="item in list4" :key="item.id">
        <div class="imgbox">
          <img :src="item.picUrl" alt="">
        </div>
        <div>
         <p class="name">
           <span>{{item.name}}</span>
           <span>{{item.presidentName}}</span>
         </p>
          <p class="yyuan">{{item.hospitalName}}</p>
          <div class="div">
            <p>评分 <span>{{item.score}}</span></p>
            <p>预约量 <span>{{item.saleNum}}</span></p>
          </div>
          <p class="sc">擅长：{{item.sellPoint}}</p>
          <el-button class="btn">立即预约</el-button>
        </div>
      </div>
    </div>
    <div class="page">
      <el-pagination
      background
      layout="pager"
      :total="total"
      @current-change="chanePage"
      >
    </el-pagination>
    </div>
  </div>
</template>

<script>
  import server from '@/service/server.js'
export default {
    name: 'index',
   components: {},
    data () {
        return {
          active: 'all',
          active2: 'all',
          active3: 'all',
          deparList: [],
          list2: [],
          list3: [],
          list4: [],
          categoryDepartment: null,
          president: null,
          level: null,
          current: 1,
          total: 0
        }
    },
    methods: {
      zjxq(id){
        this.$router.push({
          path: `/zjxq?id=${id}`
        })
      },
      depatTab(index, id) {
        this.active = index
        this.categoryDepartment = id
        this.hospitalList()
      },
      presidentTab(index, id) {
        this.active2 = index
        this.president = id
        this.hospitalList()
      },
      levelTab(index, id) {
        this.active3 = index
        this.level = id
        this.hospitalList()
      },
      chanePage(e) {
        this.current = e
        this.hospitalList()
      },
      hospitalList() {
        server.expert({
          size: 10,
          current: this.current,
          parentId: this.categoryDepartment,
          categoryPresident: this.president,
          categoryLevel: this.level
        }).then((res) => {
          this.list4 = res.data.records
          this.total = res.data.total
        })
      }
    },
    mounted(){
      document.documentElement.scrollTop = 0;
      server.department().then((res) => {
        this.deparList = res.data
      })
      server.president().then((res) => {
        this.list2 = res.data
      })
      server.level().then((res) => {
        this.list3 = res.data
      })
      this.hospitalList()
    }
}
</script>
<style lang="scss" scoped>
  .container {
    width: 1370px;
    margin: 0 auto;
    .yxtj{
      font-size: 21px;
      /*font-family: SourceHanSansCN;*/
      font-weight: 400;
      color: rgba(137, 137, 136, 1);
      margin-bottom: 20px;
      span{
        color: rgba(95, 170, 86, 1);
      }
    }
    .title {
      padding: 10px 20px;
      background-color: #FFFFFF;
      margin: 20px 0;
      font-size: 16px;
      span {
        color: #5288F0;
      }

    }
    .jgfl {
      padding: 0 20px;
      background: #FFFFFF;
      border: 1px solid #F0F0F0;
      display: flex;
      margin-top: 20px;
      .item{
        width: calc(100% - 80px);
        .items{
          border-bottom: 2px dashed rgba(243, 243, 243, 1);
          line-height: 70px;
          display: flex;
         width: 100%;
          p{
            font-size: 16px;
            /*font-family: SourceHanSansCN;*/
            font-weight: 400;
            i{
              width: 1px;
              height: 38px;
              background: #F1F1F1;
              display: inline-block;
              vertical-align: middle;
              margin-left: 16px;
            }
          }
          ul{
            display: flex;
            width: calc(100% - 100px);
            flex-wrap: wrap;
            li{
              font-size: 16px;
              font-weight: 400;
              margin-left: 20px;
              cursor: pointer;
              &.active {
                color: #CB0E07;
              }
            }
          }
        }
      }
      .zk{
        font-size: 16px;
        font-weight: 400;
        color: #347AEE;
        margin-left: auto;
        cursor: pointer;
        line-height: 70px;
      }
    }
    .shaixuan {
      padding: 20px;
      background-color: #FFFFFF;
      margin: 25px 0;
      display: flex;
      .item {
        margin: 0 20px;
        &.ac {
          color: #FF7978;
        }
      }
    }
    .yybox {
      display: flex;

      width: 1370px;
      flex-wrap: wrap;
      .item {
        width: 252px;
        border: 1px solid #E4E4E4;
        padding: 20px 10px;
        background: #fff;
        margin: 10px;
        cursor: pointer;
        box-shadow: 0px 4px 8px #eaeaea;
        &:hover {
          img {
            transform: scale(1.2);
          }
        }
        .imgbox {
          width: 133px;
          height: 133px;
          border-radius: 133px;
          margin: 0 auto 10px;
          overflow: hidden;
        }
        img {
          width: 133px;
          height: 133px;
          display: block;
          transition: all 0.5s;
        }
        .btn {
          background: #CB0E07;
          color: #FFFFFF;
          border-radius: 8px 8px 8px 8px;
          display: block;
          float: right;
        }
        p.name{
          text-align: center;
          span:nth-child(1){
            font-size: 16px;
            font-weight: 400;
            color: #347AEE;
          }
          span:nth-child(2){
            color: #000;
            font-size: 16px;
            font-weight: bold;
            margin-left: 5px;
          }
        }
        p.yyuan{
          font-size: 14px;
          color: #666;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          margin: 10px 5px;
        }
        .div{
          display: flex;
          width: 80%;
          margin: 10px auto;
          padding: 10px;
          border-bottom: 1px dashed #666;
          p:nth-child(1){
            font-size: 14px;
            color: #666;
            span{
              font-size: 16px;
              color: #ffb826;
              font-weight: bold;
            }
          }
          p:nth-child(2){
            margin-left: auto;
            font-size: 14px;
            color: #666;
            span{
              font-size: 14px;
              color: #333;
              font-weight: bold;
            }
          }
        }
        p.sc{
          font-size: 14px;
          color: #666;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          height: 40px;
          -webkit-box-orient: vertical;
          margin: 10px 5px;
        }
      }
    }
    .page {
      padding: 30px;
      text-align: center;
    }
  }
  @media (max-width: 750px) {

    .container {
      width: 100%;
      margin-top: 60px;
      .jgfl .item {
        width: auto;
      }
      .jgfl .item .items {
        line-height: 40px;
      }
      .jgfl .item .items ul {
        display: block;
        li {
          float: left;
        }
      }
      .shaixuan{
        display: none;
      }
      .yybox {
        width: calc(100% - 20px);
        display: block;
        margin: 10px;
        .item {
          margin: 0 0 10px 0;
          width: 100%;
          overflow: hidden;
          p.sc {
            height: auto;
            -webkit-line-clamp: 1;
          }
        }
      }
    }
  }
</style>
